import ContactItem from "./contactItem.component";

export default ContactItem;
